module.exports = __webpack_public_path__ + "img/grand-brasil.29f2e953.jpg";